import { render } from "./NuevoEvento.vue?vue&type=template&id=7755b86b"
import script from "./NuevoEvento.vue?vue&type=script&lang=js"
export * from "./NuevoEvento.vue?vue&type=script&lang=js"

import "./NuevoEvento.vue?vue&type=style&index=0&id=7755b86b&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__